import React from 'react'
import Navbar from '../inc/Navbar'
import Table from 'react-bootstrap/Table';
import { Link } from "react-router-dom";

import ScrollToTop from "react-scroll-to-top";
import Booklist1 from './Booklist1';
import Booklist2 from './Booklist2';
import Booklist3 from './Booklist3';
import Booklist4 from './Booklist4';
import Booklist5 from './Booklist5';
import Booklist6 from './Booklist6';
import Booklist7 from './Booklist7';
import Booklist8 from './Booklist8';
import Booklist9 from './Booklist9';
import Booklist10 from './Booklist10';
import Booklist11 from './Booklist11';
import Booklist12 from './Booklist12';

function Booklist() {
    return (
        <div>
            <Navbar />
            <br />
            <br />
            <div className="album py-1">
                <div className="container">
                    <h1> KRISHNAGAR PUBLIC SCHOOL </h1>
                </div>
            </div>

            <div className='cbscschoolnadia'>
                <div className='album py-1'>
                    <div className='container mt-3'>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li style={{ color: "white" }} className="breadcrumb-item"><Link to="/" style={{ color: "darkBLue" }} >Home</Link></li>
                                <li className="breadcrumb-item active" style={{ color: "darkBLue" }} aria-current="page">Booklist <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-double-right" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708" />
                                    <path fill-rule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708" />
                                </svg></li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            <ScrollToTop smooth top="100" color="#030E5C" />

            <br />
            <div className="container">
                <div className='welcometext'>
                    <h1 className="card-title mb-0"><b>Booklist </b></h1>
                    <div className="col-md-3">
                        <hr style={{ color: "#1D4D93" }} />
                    </div>
                    <p>Please find the Booklist of the session 2026-27 and the Syllabus for the Upcoming Assessments:</p>
                </div>
            </div>
            <div className='visitingtime'>
                <br />
                <div className="album py-1">
                    <div className="container">

                        <Table striped bordered hover variant="light">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Class</th>
                                    <th style={{color:"#081874"}}>	Download Booklist</th>

                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>1</td>
                                    <td>	Class 1</td>
                                    <td><Booklist1 /></td>

                                </tr>
                                <tr>
                                    <td>2</td>
                                    <td>Class 2</td>
                                    <td><Booklist2 /></td>

                                </tr>
                                <tr>
                                    <td>3</td>
                                    <td >Class 3</td>
                                    <td><Booklist3 /></td>

                                </tr>
                                <tr>
                                    <td>4</td>
                                    <td >Class 4</td>
                                    <td><Booklist4 />	</td>

                                </tr>
                                <tr>
                                    <td>5</td>
                                    <td >Class 5</td>
                                    <td><Booklist5 /></td>

                                </tr>
                                <tr>
                                    <td>6</td>
                                    <td >Class 6</td>
                                    <td><Booklist6 />	</td>

                                </tr>

                                <tr>
                                    <td>7</td>
                                    <td >Class 7</td>
                                    <td><Booklist7 />	</td>

                                </tr>

                                <tr>
                                    <td>8</td>
                                    <td >Class 8</td>
                                    <td><Booklist8 />	</td>

                                </tr>


                                <tr>
                                    <td>9</td>
                                    <td >Class 9</td>
                                    <td><Booklist9 />	</td>

                                </tr>


                                <tr>
                                    <td>10</td>
                                    <td >Class 10</td>
                                    <td><Booklist10 />	</td>

                                </tr>
                                   <tr>
                                    <td>11</td>
                                    <td >Class 11</td>
                                    <td><Booklist11/>	</td>

                                </tr>
 <tr>
                                    <td>12</td>
                                    <td >Class 12</td>
                                    <td><Booklist12/>	</td>

                                </tr>


                            </tbody>
                        </Table>
                    </div>
                </div>

                <br />
            </div>

        </div>
    )
}

export default Booklist